import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  APPLICATION_LIMIT,
  APPLICATION_TAB_NAME,
  AR_CONTENT_TAB, constantKeyMap, MODULE_LIMIT, RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB, RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB,
  resourceTabNaming
} from "../../constant/constants";
import { defaultLogo, FilterIcon } from "../../Icons";
import ResourceManagementSkelton from "../../components/Skeleton/ResourceManagement";
import { getAllocatedApplication, getAllocatedModuleList } from "../../apiClient/apiDataFetcher";
import { makeFilterParams, removeDuplicatesByKey, removeMatchedDataUsingKey, toggleArrayByObject, visibleAssignSectionList } from "../../utils/general";
import useDebounce from "../../hooks/useDebounce";
import SelectionLine_N from "./SelectionLine_N";
import { useDispatch } from "react-redux";
import { saveFilter, saveTotalCount } from "../../store/slice/filterOptions";

const { SimCheckBox, SearchBar } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ResourceListPanel_N = ({ activeTab, openFilter, checkedFilterItem, setSelectedResource, search, setSearch, selectedResource, checkBox,
  setCheckBox, checkBoxAll, setCheckBoxAll }) => {
  const dispatch = useDispatch();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  let queryCheckedItem = useDebounce(checkedFilterItem, 550);
  let querySearchItem = useDebounce(search, 550);
  const [loading, setLoading] = useState(false);

  const [applicationList, setApplicationList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "application"
  });

  const [moduleList, setModuleList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [environmentList, setEnvironmentList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [skillStreamList, setSkillStreamList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [skillSchoolList, setSkillSchoolList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [arContentList, setArContentList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  let renderList = {
    [RESOURCE_APPLICATION_TAB]: {
      ...applicationList,
      list: applicationList.list.filter((e) => e.uuid !== configData.config.applicationId).map((item) => ({ title: item.name, id: item.uuid, icon: item.icon })) || [],
    },
    [RESOURCE_MODULE_TAB]: {
      ...moduleList,
      list: moduleList.list.map((item) => ({ title: item.name, id: item.uuid, description: item?.versions[0]?.data?.short || null, icon: item?.versions[0]?.data?.thumbnail || defaultLogo })) || [],
    },
    [RESOURCE_ENVIRONMENT_TAB]: {
      ...environmentList,
      list: environmentList.list.map((item) => ({
        title: item.name,
        id: item.uuid,
        description: item?.versions[0]?.data?.description || null,
        icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
      })) || []
    },
    [RESOURCE_SKILL_STREAM_TAB]: {
      ...skillStreamList,
      list: skillStreamList.list.map((item) => ({
        title: item.name,
        id: item.uuid,
        description: item.description,
        icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
      })) || []
    },
    [RESOURCE_SKILL_SCHOOL_TAB]: {
      ...skillSchoolList,
      list: skillSchoolList.list.map((item) => ({
        title: item.name,
        id: item.uuid,
        description: item.description,
        icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
      })) || []
    },
    [AR_CONTENT_TAB]: {
      ...arContentList,
      list: arContentList.list.map((item) => ({
        title: item.name,
        id: item.uuid,
        description: item?.versions[0]?.data?.description || null,
        icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
      })) || []
    }

  };

  const getPaginatedAssignedModules = async (pageNumber, querySearch, selectedItem = [], resourceType) => {
    let page = pageNumber || 1;

    let fetchStates = {
      [RESOURCE_MODULE_TAB]: setModuleList,
      [RESOURCE_ENVIRONMENT_TAB]: setEnvironmentList,
      [RESOURCE_SKILL_STREAM_TAB]: setSkillStreamList,
      [RESOURCE_SKILL_SCHOOL_TAB]: setSkillSchoolList,
      [AR_CONTENT_TAB]: setArContentList,
    };

    fetchStates[resourceType]((pre) => ({ ...pre, loader: true, page: page }));

    try {
      let filterParams = {};
      if (selectedItem.length > 0) {
        filterParams = makeFilterParams(selectedItem);
      }
      let queryParams = {
        page: page,
        search: querySearch,
        ...filterParams,
      };

      let data = await getAllocatedModuleList({ UNO_URL: configData.config.UNO_URL, UUID: userData.user.uuid, queryParams, resourceType });

      let list = data.list;
      let total = data.total;

      fetchStates[resourceType]((pre) => ({
        ...pre,
        hasMore: list.length === MODULE_LIMIT,
        page: list.length === MODULE_LIMIT ? page + 1 : page,
        list: page === 1 ? [...list] : [...pre.list, ...list],
      }));

      dispatch(saveTotalCount({ data: { [resourceType]: total } }));

    } catch (error) {
      console.log(error);
    } finally {
      fetchStates[resourceType]((pre) => ({ ...pre, loader: false }));
    }
  };

  const getPaginatedApplications = async (pageNumber, querySearch, selectedItem = []) => {
    let page = pageNumber || 1;
    setApplicationList((pre) => ({ ...pre, loader: true, page: page }));
    try {
      let queryParams = {
        page: page,
        search: querySearch,
        tagIds: selectedItem.length > 0 ? selectedItem.map((e) => e.key) : null,
      };
      let data = await getAllocatedApplication({ UNO_URL: configData.config.UNO_URL, UUID: userData.user.uuid, queryParams });

      let list = data.list;
      let total = data.total;

      dispatch(saveTotalCount({ data: { [RESOURCE_APPLICATION_TAB]: total } }));

      setApplicationList((pre) => ({
        ...pre,
        hasMore: list.length === APPLICATION_LIMIT,
        page: list.length === APPLICATION_LIMIT ? page + 1 : page,
        list: page === 1 ? [...list] : [...pre.list, ...list],
      }));

    } catch (error) {
      console.log(error);
    } finally {
      setApplicationList((pre) => ({ ...pre, loader: false }));
      setLoading(false);
    }
  };

  const loadMoreData = () => {
    const mapping = {
      [RESOURCE_APPLICATION_TAB]: {
        storedValue: applicationList,
        callerFunction: getPaginatedApplications,
      },
      [RESOURCE_MODULE_TAB]: {
        storedValue: moduleList,
        callerFunction: getPaginatedAssignedModules,
      },
      [RESOURCE_ENVIRONMENT_TAB]: {
        storedValue: environmentList,
        callerFunction: getPaginatedAssignedModules,
      },
      [RESOURCE_SKILL_STREAM_TAB]: {
        storedValue: skillStreamList,
        callerFunction: getPaginatedAssignedModules,
      },
      [RESOURCE_SKILL_SCHOOL_TAB]: {
        storedValue: skillSchoolList,
        callerFunction: getPaginatedAssignedModules,
      },
      [AR_CONTENT_TAB]: {
        storedValue: arContentList,
        callerFunction: getPaginatedAssignedModules,
      },
    };

    mapping[activeTab].callerFunction(
      mapping[activeTab].storedValue.page,
      querySearchItem[activeTab],
      queryCheckedItem[activeTab],
      activeTab
    );
  };

  const fetchInitialAppData = () => {
    let _visibleSectionList = visibleAssignSectionList().map(e => e.id_link);
    if (!(_visibleSectionList.length)) return;
    setLoading(true);
    let userPermissions = _visibleSectionList.map(e => constantKeyMap[e]);
    if (userPermissions.includes(RESOURCE_APPLICATION_TAB)) getPaginatedApplications(1, querySearchItem[RESOURCE_APPLICATION_TAB], queryCheckedItem[RESOURCE_APPLICATION_TAB]);
    if (userPermissions.includes(RESOURCE_MODULE_TAB)) getPaginatedAssignedModules(1, querySearchItem[RESOURCE_MODULE_TAB], queryCheckedItem[RESOURCE_MODULE_TAB], RESOURCE_MODULE_TAB);
    if (userPermissions.includes(RESOURCE_ENVIRONMENT_TAB)) getPaginatedAssignedModules(1, querySearchItem[RESOURCE_ENVIRONMENT_TAB], queryCheckedItem[RESOURCE_ENVIRONMENT_TAB], RESOURCE_ENVIRONMENT_TAB);
    if (userPermissions.includes(RESOURCE_SKILL_STREAM_TAB)) getPaginatedAssignedModules(1, querySearchItem[RESOURCE_SKILL_STREAM_TAB], queryCheckedItem[RESOURCE_SKILL_STREAM_TAB], RESOURCE_SKILL_STREAM_TAB);
    if (userPermissions.includes(RESOURCE_SKILL_SCHOOL_TAB)) getPaginatedAssignedModules(1, querySearchItem[RESOURCE_SKILL_SCHOOL_TAB], queryCheckedItem[RESOURCE_SKILL_SCHOOL_TAB], RESOURCE_SKILL_SCHOOL_TAB);
    if (userPermissions.includes(AR_CONTENT_TAB)) getPaginatedAssignedModules(1, querySearchItem[AR_CONTENT_TAB], queryCheckedItem[AR_CONTENT_TAB], AR_CONTENT_TAB);
  };

  useEffect(() => {
    fetchInitialAppData();
  }, [queryCheckedItem, querySearchItem]);

  const handleSetSearch = (e) => {
    setSearch((pre) => ({ ...pre, [activeTab]: e.target.value }));
  };

  const handleSelectCheckBox = (e) => {
    let list = renderList[activeTab].list;

    setCheckBox(pre => {
      return {
        ...pre,
        [activeTab]: !pre[activeTab]
      }
    });

    if (e) {
      setSelectedResource(prev => {
        let updatedList = [...prev[activeTab], ...list];
        return ({
          ...prev,
          [activeTab]: removeDuplicatesByKey(updatedList, "id")
        })
      })
    } else {
      // setSelectedResource(prev => {
      //   let currentList = [...prev[activeTab]];
      //   return ({
      //     ...prev,
      //     [activeTab]: removeMatchedDataUsingKey(currentList, list, "id")
      //   })
      // })
      handleClearAllActiveItems(activeTab);
    }
  }

  const handleSelectResource = (item, status) => {
    console.log("status ", status);
    setSelectedResource(prev => {
      return {
        ...prev,
        [activeTab]: toggleArrayByObject(prev[activeTab], item)
      }
    });
    if (!status) {
      setCheckBox(pre => ({
        ...pre,
        [activeTab]: false
      }))
      setCheckBoxAll(pre => ({
        ...pre,
        [activeTab]: false
      }))
    }
  };

  const handleSelectAllActiveItems = (currentTab) => {
    setCheckBoxAll(pre => ({
      ...pre,
      [currentTab]: true
    }))
  }

  const handleClearAllActiveItems = (currentTab) => {
    setCheckBoxAll(pre => ({
      ...pre,
      [currentTab]: false
    }));
    setCheckBox(pre => ({
      ...pre,
      [currentTab]: false
    }));
    setSelectedResource(prev => ({
      ...prev,
      [currentTab]: []
    }))
  }

  let renderDisplayData = renderList[activeTab] || null;

  return (
    <div className="resource-content">
      <section>
        <div className="carddata colorborder mb-0">
          <div className="applicationsheader">
            <div className="w-100">
              <div className=" d-flex w-100 gap-2">
                <h6 className="card-heading w-100"> { ((loading || !activeTab) ? <Skeleton width="70%" height={20} /> : resourceTabNaming[activeTab])} </h6>
              </div>
              <p className="card-detail w-100"> { ((loading || !activeTab ) ? <Skeleton width="50%" height={15} /> : `Select the ${resourceTabNaming[activeTab]} you want to assign to a group and user.`)} </p>
            </div>
            {(!loading && activeTab) && <div className="search-parent">
              <div className="searchwithborder search-bar">
                <SearchBar onClick={() => { }} placeholder="Search..." value={search[activeTab]} onChange={(e) => handleSetSearch(e)} />
              </div>

              <div className="filterbtn" onClick={() => openFilter()}>
                <div className="btninadjust">
                  <FilterIcon />
                  {(queryCheckedItem[activeTab] || []).length > 0 && <span className="filter-active-span">{""}</span>}
                </div>
              </div>
            </div>}
          </div>

          <SelectionLine_N handleSelectCheckBox={handleSelectCheckBox} checkBox={checkBox} activeTab={activeTab}
            selectedResource={selectedResource} handleSelectAllActiveItems={handleSelectAllActiveItems} handleClearAllActiveItems={handleClearAllActiveItems} checkBoxAll={checkBoxAll} loading={loading} />


          {renderDisplayData &&
            <div className="listdata scrollable-container" id="scrollableDivResources">
              {(renderDisplayData.loader && renderDisplayData.page == 1) ?
                <ResourceManagementSkelton length="4" width={activeTab === RESOURCE_APPLICATION_TAB ? "50px" : "70px"} circle={activeTab === RESOURCE_APPLICATION_TAB} />
                :
                <InfiniteScroll
                  scrollThreshold={0.7}
                  dataLength={renderDisplayData.list.length}
                  next={() => loadMoreData()}
                  hasMore={renderDisplayData.hasMore}
                  loader={<ResourceManagementSkelton length="4" width={activeTab === RESOURCE_APPLICATION_TAB ? "50px" : "70px"} circle={activeTab === RESOURCE_APPLICATION_TAB ? true : false} />}
                  scrollableTarget="scrollableDivResources"
                >
                  {renderDisplayData.list.map((item) => (
                    <div className="modulelist" key={item.id}>
                      <div className="mcontewrap">
                        <SimCheckBox
                          checked={selectedResource[activeTab].find((value) => value.id === item.id) ? true : false}
                          onChange={(e) => handleSelectResource({ id: item.id, name: item.title, avatar: item.icon }, e.target.checked)}
                          id={item.id}
                        />
                        <div className="applicationthumb">
                          <img
                            src={item.icon || defaultLogo}
                            alt={item.title}
                            referrerPolicy="no-referrer"
                            className={!item.icon ? "resource-default-logo" : ""}
                          />
                        </div>
                        <div>
                          <h6>{item.title}</h6>
                        </div>
                      </div>
                    </div>
                  ))}
                </InfiniteScroll>
              }
            </div>
          }

        </div>
      </section>
    </div>
  );
};

export default ResourceListPanel_N;
